import { render, staticRenderFns } from "./MainAlert.vue?vue&type=template&id=494b940e&scoped=true&"
import script from "./MainAlert.vue?vue&type=script&lang=js&"
export * from "./MainAlert.vue?vue&type=script&lang=js&"
import style0 from "./MainAlert.vue?vue&type=style&index=0&id=494b940e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b940e",
  null
  
)

export default component.exports